import { Link, useLocation } from "react-router-dom"
import { Star, MessageSquare, Settings, LayoutDashboard, Calendar } from "lucide-react"

export function OwnerMobileNavbar({ user, onLogout, newMessageVillas }) {
  const location = useLocation()
  const path = location.pathname
  const hasNewMessages = newMessageVillas && newMessageVillas.size > 0

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-black text-white shadow-lg z-30 md:hidden">
      <div className="flex justify-around items-center py-2 px-1">
        <Link
          to="/owner"
          className={`flex flex-col items-center py-1 ${path === "/owner" ? "text-blue-400" : "text-white"}`}
        >
          <LayoutDashboard className={`h-5 w-5 ${path === "/owner" ? "stroke-blue-400" : "stroke-white"}`} />
          <span className="text-[10px] mt-0.5">Dashboard</span>
        </Link>
        <Link
          to="/owner/reviews"
          className={`flex flex-col items-center py-1 ${path === "/owner/reviews" ? "text-blue-400" : "text-white"}`}
        >
          <Star className={`h-5 w-5 ${path === "/owner/reviews" ? "stroke-blue-400" : "stroke-white"}`} />
          <span className="text-[10px] mt-0.5">Reviews</span>
        </Link>
        <Link
          to="/owner/bookings"
          className={`flex flex-col items-center py-1 ${path === "/owner/bookings" ? "text-blue-400" : "text-white"}`}
        >
          <Calendar className={`h-5 w-5 ${path === "/owner/bookings" ? "stroke-blue-400" : "stroke-white"}`} />
          <span className="text-[10px] mt-0.5">Bookings</span>
        </Link>
        <Link
          to="/owner/chats"
          className={`flex flex-col items-center py-1 relative ${path === "/owner/chats" ? "text-blue-400" : "text-white"}`}
        >
          <MessageSquare className={`h-5 w-5 ${path === "/owner/chats" ? "stroke-blue-400" : "stroke-white"}`} />
          {hasNewMessages && (
            <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full animate-blink"></span>
          )}
          <span className="text-[10px] mt-0.5">Messages</span>
        </Link>
        <Link
          to="/owner/management"
          className={`flex flex-col items-center py-1 ${path === "/owner/management" ? "text-blue-400" : "text-white"}`}
        >
          <Settings className={`h-5 w-5 ${path === "/owner/management" ? "stroke-blue-400" : "stroke-white"}`} />
          <span className="text-[10px] mt-0.5">Settings</span>
        </Link>
      </div>
      <style jsx>{`
        @keyframes blink {
          0% { opacity: 1; }
          50% { opacity: 0.3; }
          100% { opacity: 1; }
        }
        .animate-blink {
          animation: blink 1s infinite;
        }
      `}</style>
    </nav>
  )
}